onProductCarrierChange<template>
  <v-container
    id="eligibilityGroupEdit"
    class="pa-0"
  >
    <v-row>
      <v-col
        cols="12"
      >
        <v-text-field
          v-model="editedItem.eligibilityGroup"
          :error-messages="safeFormErrors.EligibilityGroup"
          :disabled="disabled"
          label="Eligibility Group"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'EligibilityGroupEdit',

    props: {
      openEnrollment: {
        type: Object,
        default: null,
      },
      formErrors: {
        type: Object,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      value: {
        type: Object,
        default: null,
      },
    },

    data: () => ({
      editedItem: null,
    }),

    computed: {
      safeFormErrors () {
        return this.formErrors || {}
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.editedItem = this.value
      },

      transformItem () {
        this.editedItem.openEnrollmentId = this.openEnrollment.id

        return this.editedItem
      },

      onChange () {
        this.transformItem()
        this.$emit('update:value', this.editedItem)
        this.$emit('change', this.editedItem)
      },
    },
  }
</script>
